import { all, call, takeLatest } from "redux-saga/effects"

import AdminInvoicesSagas from "./Containers/AdminInvoicesPage/saga"
import AdminUsersSagas from "./Containers/AdminUsersPage/saga"
import AlertsPage from "./Containers/AlertsPage/saga"
import BalanceSagas from "./Containers/Balance/saga"
import BusinessAccountsSagas from "./Containers/BusinessAccountsPage/saga"
import BusinessDetailsSagas from "./Containers/BusinessDetailsBlock/saga"
import CreditsSagas from "./Containers/CreditsPage/saga"
import DashboardSagas from "./Containers/DashboardPage/saga"
import HealthSagas from "./Containers/Health/saga"
import InvoicesSagas from "./Containers/InvoiceHistoryBlock/saga"
import { AuthTypes } from "./Containers/LoginPage/reducer"
import {
  acceptAdminInvite,
  apiAuthSaga,
  changeEmail,
  checkPassword,
  commitAdminSecurity2FA,
  confirm2FASetup,
  confirmAdminSecurity2FA,
  confirmEmail,
  confirmEmailInit,
  confirmPassword,
  createAccount,
  createUserPassword,
  generate2FASetup,
  generateAdminSecurity2FA,
  logout,
  resendVerificationLink,
  sendConfirmEmail,
  shopifyAuth,
  signIn,
  socialAuth,
  socialAuthConnect,
  socialAuthDelete,
  verify2FA
} from "./Containers/LoginPage/saga"
import MarketingSagas from "./Containers/MarketingPage/saga"
import PaymentMatchingSagas from "./Containers/PaymentMatchingPage/saga"
import PerksAdminSagas from "./Containers/PerksAdminPage/saga"
import PerksSagas from "./Containers/PerksPage/saga"
import PublicApiSagas from "./Containers/PersonalSettings/PublicAPI/saga"
import PricingSagas from "./Containers/PricingPage/saga"
import ReferralsSagas from "./Containers/Referrals/saga"
// import RequestsDescriptorsSagas from './Containers/RequestsPage/RequestsDescriptors/saga';
import RequestsAutoRefundSagas from "./Containers/RequestsPage/RequestsAutoRefund/saga"
import RequestsDigitalReceiptSagas from "./Containers/RequestsPage/RequestsDigitalReceipt/saga"
import RequestsEnrollmentsSagas from "./Containers/RequestsPage/RequestsEnrollments/saga"
import RequestsGiftsSagas from "./Containers/RequestsPage/RequestsGifts/saga"
import RequestsIntegrationsSagas from "./Containers/RequestsPage/RequestsIntegrations/saga"
// RequestsReceipts migrated to Redux Toolkit thunks — see redux/ subfolder.
import RequestsVerifiInformSagas from "./Containers/RequestsPage/RequestsVerifiInform/saga"
import RequestsWithdrawalSagas from "./Containers/RequestsPage/RequestsWithdrawal/saga"
import RequestsSagas from "./Containers/RequestsPage/saga"
import SettingSagas from "./Containers/Setting/saga"
import UserSagas from "./Containers/User/saga"
import UsersSagas from "./Containers/UsersPage/saga"
/* ------------- Types ------------- */
import { StartupTypes } from "./Redux/StartupRedux"
/* ------------- Sagas ------------- */
import { startup } from "./Sagas/StartupSagas"
import API from "./Services/Api"

/* ------------- API ------------- */

// The API we use is only used from Sagas, so we create it here and pass along
// to the sagas which need it.
const api = API

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    // some sagas only receive an action
    takeLatest(StartupTypes.STARTUP, startup),

    takeLatest(AuthTypes.SIGN_IN_REQUEST, signIn, api),
    takeLatest(AuthTypes.SIGN_UP_REQUEST, createUserPassword, api),
    takeLatest(AuthTypes.SHOPIFY_AUTH_REQUEST, shopifyAuth, api),
    takeLatest(AuthTypes.SOCIAL_AUTH_REQUEST, socialAuth, api),
    takeLatest(AuthTypes.RESEND_VERIFICATION_LINK_REQUEST, resendVerificationLink, api),
    takeLatest(AuthTypes.CREATE_ACCOUNT_REQUEST, createAccount, api),
    takeLatest(AuthTypes.CHANGE_EMAIL_REQUEST, changeEmail, api),
    takeLatest(AuthTypes.SEND_CONFIRM_EMAIL_REQUEST, sendConfirmEmail, api),
    takeLatest(AuthTypes.CONFIRM_EMAIL_REQUEST, confirmEmail, api),
    takeLatest(AuthTypes.CONFIRM_EMAIL_INIT_REQUEST, confirmEmailInit, api),
    takeLatest(AuthTypes.CHECK_PASSWORD_REQUEST, checkPassword, api),
    takeLatest(AuthTypes.CONFIRM_PASSWORD_REQUEST, confirmPassword, api),
    takeLatest(AuthTypes.VERIFY2_FA_REQUEST, verify2FA, api),
    takeLatest(AuthTypes.GENERATE2_FA_SETUP_REQUEST, generate2FASetup, api),
    takeLatest(AuthTypes.CONFIRM2_FA_SETUP_REQUEST, confirm2FASetup, api),
    takeLatest(AuthTypes.GENERATE_ADMIN_SECURITY2_FA_REQUEST, generateAdminSecurity2FA, api),
    takeLatest(AuthTypes.CONFIRM_ADMIN_SECURITY2_FA_REQUEST, confirmAdminSecurity2FA, api),
    takeLatest(AuthTypes.COMMIT_ADMIN_SECURITY2_FA_REQUEST, commitAdminSecurity2FA, api),
    takeLatest(AuthTypes.ACCEPT_ADMIN_INVITE_REQUEST, acceptAdminInvite, api),
    takeLatest(AuthTypes.LOGOUT, logout, api),
    takeLatest(AuthTypes.SOCIAL_AUTH_DELETE_REQUEST, socialAuthDelete, api),
    takeLatest(AuthTypes.SOCIAL_AUTH_CONNECT_REQUEST, socialAuthConnect, api),
    call(apiAuthSaga),
    call(UserSagas),
    call(DashboardSagas),
    call(AlertsPage),
    call(SettingSagas),
    call(BusinessAccountsSagas),
    call(AdminUsersSagas),
    call(RequestsEnrollmentsSagas),
    // call(RequestsDescriptorsSagas),
    call(RequestsAutoRefundSagas),
    call(RequestsDigitalReceiptSagas),
    call(RequestsIntegrationsSagas),
    call(RequestsGiftsSagas),
    call(RequestsWithdrawalSagas),
    call(RequestsVerifiInformSagas),
    call(AdminInvoicesSagas),
    call(PricingSagas),
    call(InvoicesSagas),
    call(UsersSagas),
    call(CreditsSagas),
    call(BalanceSagas),
    call(MarketingSagas),
    call(RequestsSagas),
    call(ReferralsSagas),
    call(BusinessDetailsSagas),
    call(PublicApiSagas),
    call(HealthSagas),
    call(PerksSagas),
    call(PerksAdminSagas),
    call(PaymentMatchingSagas)
  ])
}
